module.exports = __webpack_public_path__ + "static/media/no-endcap.a26c60b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-endcap.jpg
// module id = 47
// module chunks = 0